export enum RebateTakeoutOptions {
  GrowWithUs = 27,
  PartnerWithUs = 33,
}
